import cn from 'client/utils/cn';

import React, { Component } from 'react';

import Card from 'client/components/card';
import Date from 'client/components/date';

import './index.css';

const b = cn('blog-item');

interface Props {
    date: string;
    title: string;
    url: string;
    socialImage?: string;
}

class BlogItem extends Component<Props> {
    render() {
        const {
            date,
            title,
            url,
            socialImage
        } = this.props;

        return (
            <div className={b()}>
                <Card noPadding stretched>
                    <a className={b('link')} href={url}>
                        {
                            socialImage &&
                            <div className={b('image-box')}>
                                <img className={b('image')} src={socialImage} />
                            </div>
                        }
                        <div className={b('content')}>
                            <Date dateStart={date} />

                            <h2 className={b('title')}>{title}</h2>
                        </div>
                    </a>
                </Card>
            </div>
        );
    }
}

export default BlogItem;
